<template>
  <div>
    <data-table
      :data="userData"
      :is-hoverable="isHoverable"
      :is-focusable="isFocusable"
      :perPage="perPage"
      :total="total"
      :currentPage="currentPage"
      :isPaginated="isPaginated"
      :backEndPagination="isBackendPaginated"
      :onPageChange="onPageChange"
      :defaultSort="defaultSort"
      :defaultSortDirection="defaultSortDirection"
      class= "table"
    >
      <template slot-scope="props">
        <b-table-column field="fullname" label="Full Name" sortable defaultSort>{{ props.row.full_name }}</b-table-column>
        <b-table-column field="username" label="User Name" sortable defaultSort>{{ props.row.user_name }}</b-table-column>


        <b-table-column field="email_address" label="Email Address" >
          <span>{{ props.row.email }}</span>
        </b-table-column>


        <b-table-column field="role" label="User Role" sortable>{{ props.row.role }}</b-table-column>

        <b-table-column field="activation_date" label="Date of Activation" sortable>
          <span class="tag is-success"> {{ new Date(props.row.created_at).toLocaleDateString() }}</span>
        </b-table-column>


        <!-- ACTIONS -->
        <b-table-column field="actions" label="Actions" >
          <div class="columns is-mobile">
            <!-- View the user -->
            <div class="column" v-if="canView">
              <b-tooltip label="View user" position="is-left" multilined>
                <a class="action-item" @click.prevent="viewUser(props.row)">
                  <b-icon type="is-primary" icon="eye" ></b-icon><span class="action-text">View</span>
                </a>
              </b-tooltip>
            </div>
            <!-- EOF view the user -->

            <!-- Update the user -->
            <div class="column" v-if="canUpdate">
              <b-tooltip label="Update User Information" position="is-left" multilined>
                <a class="action-item" @click.prevent="updateUser(props.row)">
                  <b-icon type="is-success" icon="update" ></b-icon><span class="action-text">Update</span>
                </a>
              </b-tooltip>
            </div>
            <!-- EOF Update -->

            <!-- Delete a user -->
            <div class="column" v-if="canDelete">
              <b-tooltip label="Delete this user" position="is-left" multilined>
                <a class="action-item" @click.prevent="deleteUser(props.row)">
                  <b-icon type="is-danger" icon="close-circle" ></b-icon><span class="action-text">Delete</span>
                </a>
              </b-tooltip>
            </div>
            <!-- EOF Delete -->
          </div>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="alert-box" size="is-large"></b-icon>
            </p>
            <h2>No users available for viewing</h2>
          </div>
        </section>
      </template>
    </data-table>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
  </div>
</template>

<script>
import DataTable from "@/modules/commonModule/components/dataTable/Main";
import UpdateComponent from "../views/UpdateUser"
import DeleteComponent from "../views/DeleteUser"

export default {
  name: "UsersTable",

  components: {
    DataTable,
  },

  props: {
    userData: { type: Array, required: true },
    canUpdate: {type: Boolean},
    canDelete: {type: Boolean},
    canView: {type: Boolean},
    defaultSort:{type: Array},
    defaultSortDirection:{type: String},
    isPaginated: { type: Boolean, default: true },
    isBackendPaginated: { type: Boolean, default: true },
    total: { type: Number, default: 0 },
    perPage: { type: Number, default: 25 },
    currentPage: { type: Number, default: 1 },
    onPageChange: {
      type: Function,
      default: () => {
        console.log("Empty onPageChange called from Shipping Request List");
      }
    }
  },

  data() {
    return {
      isHoverable: true,
      isLoading: false,
      isFocusable: false
      // currentPage: 1
    };
  },

  methods: {
      updateUser: function(user){
          this.$modal.open({
              parent: this,
              component: UpdateComponent,
              hasModalCard: true,
              props: {
                  user_details: user
              }              
          })
      },
      deleteUser: function(user){
          this.$modal.open({
              parent: this,
              component: DeleteComponent,
              hasModalCard: true,
              props: {
                  user_details: user
              }              
          })
      }

  }
};
</script>

<style lang="scss" scoped>
.action-item {
  border: none;
  &:hover {
    cursor: pointer;
  }
}
</style>

